import React, { ReactNode } from 'react';
import { MobileListItemGoBackBtn } from './MobileListItemGoBackBtn';

interface MobileMenuListWrapperProps {
  id: string;
  children: ReactNode;
  backBtnText: string;
  level: number;
  name: string;
}

export const MobileMenuListWrapper = ({
  id,
  children,
  backBtnText,
  level,
  name,
}: MobileMenuListWrapperProps) => {
  return (
    <ul
      style={{
        height: window.innerHeight - 56 + 'px',
      }}
      className='l-header-mobile-menu-list move-from-left mm-mobile-ul hidden'
      id={id}
    >
      <MobileListItemGoBackBtn level={level} text={backBtnText} />
      <li className='l-header-mobile-menu-item headline mobile-mm-header-title'>{name}:</li>
      {children}
    </ul>
  );
};
